import { createSelector } from '@reduxjs/toolkit'

import { getSecurity } from '../../root.selectors'

export const getSecurityUsers = createSelector(getSecurity, (security) => security.users)
